<template>
  <div>
    <b-card no-header>
      <b-row>
        <b-col cols="12" md="6">
          <template v-for="(m, index) in filterModel(['name', 'code'])">
            <div :key="'kode_rekening_' + index">
              <detail-group-input
                :ref="index"
                :type="m.type"
                :label="typeof m.label === 'string' ? m.label : null"
                :need-label="true"
                v-model="m.value"
                :id="index"
              />
            </div>
          </template>
        </b-col>
      </b-row>
      <div>
        <b-button
          :to="'/kode-rekening/'"
          variant="secondary"
          class="ml-3 float-right"
          >Kembali</b-button
        >
      </div>
    </b-card>

    <b-modal hide-footer id="modal-1" title="Tambah Sub Kode Rekening">
      <ValidationObserver ref="form">
        <form>
        <template
          v-for="(m, index) in filterSubRekeningModel([
            'code',
            'name',
            'budget',
          ])"
        >
          <div :key="index">
            <form-group-input
              :ref="index"
              :type="m.type"
              :label="typeof m.label === 'string' ? m.label : null"
              :options="
                m.type === 'radio'
                  ? getClassicOptions(index)
                  : getOptions(index)
              "
              :need-label="true"
              v-model="m.value"
              :rules="typeof m.rules !== 'undefined' ? m.rules : null"
              :disabled="typeof m.disabled !== 'undefined' ? m.disabled : null"
              :id="index"
            />
          </div>
        </template>

        <b-button variant="primary" type="button" @click.prevent="onSubmit">Submit</b-button>
      </form>
      </ValidationObserver>
    </b-modal>

    <b-card class="mt-3">
      <h5>Sub Kode Rekening</h5>

      <b-button v-b-modal.modal-1 variant="primary" class="mt-0 mb-2"
          >Tambah Sub Kode Rekening</b-button
        >

        <el-table
        empty-text="Tidak ada data yang tersedia"
          :data="account_code_childs"
          style="width: 100%">
          <el-table-column
            prop="code"
            label="Kode"
            min-width="180">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Rincian Objek"
            min-width="180">
          </el-table-column>
          <el-table-column
            prop="budget"
            label="Budget"
            min-width="100">
          </el-table-column>
          <el-table-column
            prop="action"
            label=""
            width="100">
            <template slot-scope="scope">
              <b-row class="justify-content-center table-actions">
              <b-button variant="info" size="sm" class="mb-0 text-center edit">
                <font-awesome-icon icon="pencil-alt"/>
              </b-button>
              <b-button @click.prevent="onDelete(scope.row.id)" variant="danger" size="sm" type="button" class="mb-0 text-center delete ml-1">
                <font-awesome-icon icon="trash"/>
              </b-button>
            </b-row>
            </template>
          </el-table-column>
        </el-table>

      <!-- <b-tabs fill pills card>
        <b-tab title="Detail Unit Kegiatan">
          <b-card-text
            v-if="typeof account_code_childs.length === 'undefined'"
            class="text-center"
          >
            <span class="text-muted">Data Unit Kegiatan Belum Tersedia</span>
          </b-card-text>
          <b-card-text v-else>
            <div class="accordion" role="tablist">
              <b-card
                v-for="account_code_child in account_code_childs"
                :key="account_code_child.id"
                no-body
                class="mb-1"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="account_code_child.id" variant="info">{{
                    account_code_child.name
                  }}</b-button>
                </b-card-header>
                <b-collapse
                  :id="account_code_child.id"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-row>
                      <b-col cols="6">
                        <h6>Kode Rekening</h6>
                        <p>{{ account_code_child.code }}</p>
                      </b-col>
                      <b-col cols="6">
                        <h6>Budget</h6>
                        <p>Rp. {{ $formatPrice(account_code_child.budget) }}</p>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs> -->
    </b-card>
  </div>
</template>

<script>
import { setModelValue, scrollToError, saveProcess  } from "@/_helpers";
import detailGroupInput from "@/components/DetailGroupInput.vue";
import formGroupInput from "@/components/FormGroupInput.vue";
import Rekening from "@/models/Rekening.js";
import SubRekening from "@/models/SubRekening.js";

const rekeningModel = new Rekening();
const subRekeningModel = new SubRekening();

export default {
  components: {
    detailGroupInput,
    formGroupInput,
  },
  watch: {
    "$route.params.id": function (val) {
      if (val !== undefined) {
        this.getDetail();
      }
    },
  },
  data() {
    return {
      isLoading: false,
      account_code_childs: [],
      rekeningModel: rekeningModel.init(),
      subRekeningModel: subRekeningModel.init(),
    };
  },
  mounted() {
    this.subRekeningModel.parent_id.type = "hidden";
    this.subRekeningModel.parent_id.value = this.$route.params.id
    this.getDetail();
    this.getChildAccountCodes();
  },
  methods: {
    getChildAccountCodes() {
      rekeningModel.list({
        'parent_id': this.$route.params.id,
        'limit': 10000
      }).then(resp => {
        this.account_code_childs = resp.data;
      })
    },
    filterModel(search) {
      const filtered = Object.entries(this.rekeningModel).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    filterSubRekeningModel(search) {
      const filtered = Object.entries(this.subRekeningModel).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    getOptions(key) {
      return typeof this.subRekeningModel[key].options !== "undefined"
        ? objectToOptions(this.subRekeningModel[key].options)
        : null;
    },
    getClassicOptions(key) {
      return typeof this.subRekeningModel[key].options !== "undefined"
        ? classicObjectToOptions(this.subRekeningModel[key].options)
        : null;
    },
    getDetail() {
      this.isLoading = true;
      rekeningModel
        .find(this.$route.params.id, {
          detail: 1,
        })
        .then((resp) => {
          this.isLoading = false;
          let response = {};
          Object.keys(resp).forEach((key) => {
            response[key] = resp[key];
          });
          setModelValue(this.rekeningModel, response);
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== "production") {
            console.error(error);
          }
          this.isLoading = false;
        });
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success || this.isLoading) {
          scrollToError(this.$refs.form);
          return false;
        }
        saveProcess(this.subRekeningModel)
          .then((model) => {
            subRekeningModel
              .create(model)
              .then((resp) => {
                this.isLoading = false;
                this.getChildAccountCodes()
                this.$bvModal.hide('modal-1')
                this.$store.dispatch(
                  "notification/success",
                  "Data sub kode rekening berhasil disimpan."
                );
                // this.$router.push("/kode-rekening/" + resp.id);
              })
              .catch((error) => {
                this.isLoading = false;
                this.$store.dispatch("notification/error", error);
              });
          })
          .catch(() => {});
      });
    },
    onDelete(id) {
      this.$swal.fire({
        title: "Anda Yakin Akan Menghapus Data Ini?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          subRekeningModel.delete(id).then(() => {
            this.$store.dispatch('notification/success', 'Berhasil menghapus.')
            this.getChildAccountCodes()
          }).catch((error) => {
            this.$store.dispatch('notification/error', error)
            console.log(error)
          })
        }
      })
    },
  },
};
</script>